module.exports = __webpack_public_path__ + "static/visit-duncan-hall-ecd9e5e07ed320a6b8750466d88f0bb6.jpeg";